import { gql } from '@apollo/client';

export const CREATE_TOOL_ORDER_INVENTORY = gql`
  mutation CreateToolOrderInventory($toolOrderInventoryInput: ToolOrderInventoryInput!) {
    createToolOrderInventory(toolOrderInventoryInput: $toolOrderInventoryInput) {
      data {
        id
        toolInventoryId
        toolOrderCatalogId
        dispatchQuantity
        dispatchedBy
      }
      error
    }
  }
`;

export const GET_TOOL_INVENTORY = gql`
  query GetToolInventory($searchInput: SearchInput!) {
    searchToolInventories(searchInput: $searchInput) {
      items {
        id
        barCode
        description
        toolRoomId
        projectId
        barCodeId
        limitCount
        onHandCount
        toolCatalogId
        toolCatalog {
          id
          inventoryType
          uomId
          uom {
            abbreviation
            id
          }
        }
        totalCount
      }
    }
  }
`;
export const PICK_TOOL_ORDER_INVENTORY = gql`
  mutation PickInventory($pickToolOrderInventoryInput: PickToolOrderInventoryInput!) {
    pickInventory(pickToolOrderInventoryInput: $pickToolOrderInventoryInput) {
      error
      toolOrderCatalog {
        id
        alreadyIssuedCount
        toolOrderId
        toolCatalogId
        quantity
        dispatcherComments
        requesterComments
        requesterCommentsBy
        requesterCommentsByUser {
          id
          firstName
          lastName
          employee {
            id
            imageUrl
            persona
          }
        }
        toolCatalog {
          id
          bscnPartNumber
          name
          inventoryType
          toolCategoryId
          uomId
          isFavorite
          toolCatalogImageUrl
          uom {
            id
            abbreviation
          }
        }
        toolOrderInventories {
          id
          # checkedIn fields are no longer part of tool order inventory
          dispatchQuantity
          status
          toolInventoryId
          toolOrderCatalogId
          dispatcherComments
          dispatcherCommentsBy
          dispatcherCommentsByUser {
            firstName
            lastName
          }
          toolInventory {
            id
            barCode
            toolCatalogId
            description
            isSerialized
            onHandCount
          }
        }
      }
    }
  }
`;

export const SEARCH_TOOL_INVENTORY_ORDER_FOR = gql`
  query SearchToolOrderInventoryByOrderedFor($userProjectId: String) {
    searchToolOrderInventoryByOrderedFor(userProjectId: $userProjectId) {
      items {
        id
        dispatchQuantity
        toolInventory {
          id
          barCode
          isSerialized
          description
          toolRoomId
          toolCatalogId
          toolCatalog {
            id
            bscnPartNumber
            name
            toolCatalogImageUrl
            uomId
            uom {
              id
              abbreviation
            }
          }
        }
        toolOrderCatalogId
      }
    }
  }
`;
export const UPDATE_TOOL_ORDER_INVENTORY = gql`
  mutation UpdateToolOrderInventory($updateToolOrderInventoryInput: UpdateToolOrderInventoryInput!) {
    updateToolOrderInventory(updateToolOrderInventoryInput: $updateToolOrderInventoryInput) {
      id
      errors
      toolOrderInventory {
        id
        dispatchQuantity
        createdDate
        createdBy
        updatedDate
        updatedBy
        toolOrderCatalogId
        toolInventoryId
        status
        toolInventory {
          id
          barCode
        }
        toolOrderCatalog {
          id
          alreadyIssuedCount
        }
        dispatcherComments
        dispatcherCommentsBy
      }
    }
  }
`;
export const DELETE_TOOL_ORDER_INVENTORY = gql`
  mutation DeleteToolOrderInventory($deleteToolOrderInventoryInput: DeleteToolOrderInventoryInput!) {
    deleteToolOrderInventory(deleteToolOrderInventoryInput: $deleteToolOrderInventoryInput) {
      id
      errors
    }
  }
`;
